import React, { useCallback } from 'react'
import { Box, IconButton, Menu, MenuProps, SxProps } from '@mui/material'

interface Props extends Pick<MenuProps, 'anchorOrigin' | 'transformOrigin' | 'disableScrollLock'> {
  actions: React.ReactElement[]
  icon: React.ReactNode
  anchorEl: null | HTMLElement
  closeMenu: () => void
  handleClick: (event: React.MouseEvent<HTMLElement>) => void
  containerStyle?: string
  containerSx?: SxProps
}

/**
 * This Component is a IconButton with an attached Mui-Menu. When clicking the icon the menu opens an the options can be used
 * @param actions an array of Mui-MenuItems
 * @param icon the icon used for the IconButton
 */
const ActionMenuButton: React.VFC<Props> = ({
  actions,
  icon,
  anchorEl,
  handleClick,
  closeMenu,
  containerStyle,
  anchorOrigin,
  transformOrigin,
  disableScrollLock,
  containerSx,
}) => {
  const open = Boolean(anchorEl)

  const handleClose = useCallback((): void => {
    closeMenu()
  }, []) // eslint-disable-line

  return (
    <Box className={containerStyle} sx={containerSx}>
      <IconButton onClick={handleClick} color="inherit">
        {icon}
      </IconButton>
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        disableScrollLock={disableScrollLock}
      >
        {actions.map(action => action)}
      </Menu>
    </Box>
  )
}

export default ActionMenuButton
